const w = window;

const ww = ( w.innerWidth < w.screen.width ) ? w.innerWidth : w.screen.width; // get proper width
const wh = ( w.innerHeight < w.screen.height ) ? w.innerHeight : window.screen.height; // get proper width
const mw = 1920; // min width of site
const mh = 1080; // min width of site
const ratioW =  ww / mw; // calculate ratiofitToScreen
const ratioH =  wh / mh; // calculate ratio

const fitToScreen = () => {
    if( ww < mw || wh < mh){ // smaller than minimum size
        const minRation = ratioW < ratioH ? ratioW : ratioH;
        document.getElementById("app").style.width = '1920px';
        document.getElementById("app").style.height = '1080px';
        document.getElementById("app").style.overflow = 'hidden';

        document.getElementById("app").style.transformOrigin = "top left";
        document.getElementById("app").style.transform = `scale(${minRation})`;
    }
};

const getScale = () => {
    if( ww < mw || wh < mh){ // smaller than minimum size
        return ratioW < ratioH ? ratioW : ratioH;
    }
    else return 1
}
export {fitToScreen, getScale}